import React from 'react';
import { IoIosArrowBack } from 'react-icons/io';

const MobFixedHeader = ({ title = "MODO", onBack }) => {
  return (
    <div className="fixed top-0 left-0 w-full h-[70px] bg-white shadow-md flex items-center px-2 z-50">
      <button
        className="text-2xl text-gray-700 mr-4"
        onClick={()=>{onBack(title)}}
        aria-label="Go back"
      >
        <IoIosArrowBack />
      </button>
      <h1 className="headingText text-coalBlack">{title}</h1>
    </div>
  );
};

export default MobFixedHeader;
